// extracted by mini-css-extract-plugin
module.exports = {"sticker":"sticker___1oNsW","sticker-inner":"sticker-inner___1ZE_J","stickerInner":"sticker-inner___1ZE_J"};